import { useScreens } from "hooks";
import { Order } from "screens";

export default function Screens(){
    return(
    <>
        <Order />
    </>
    )
}